import { gql } from '@apollo/client';

import { assessmentDetailsFragment } from './sections/details/details.graphql';
import { AssessmentOutcomesFragment } from './sections/outcomes/outcomes.graphql';
import { assessmentStimulusFragment } from './sections/stimulus/stimulus.graphql';
import { assessmentWorksheetsFragment } from './sections/worksheets/worksheets.graphql';
import { assessmentForLearningToolFragment } from 'approot/assessment/sections/assessment-for-learning-tool/assessment-for-learning-tool.graphql';
import {
  assessmentHeroImageFragment,
  assessmentLandscapeImageFragment,
  assessmentSquareImageFragment,
} from './sections/images/hero-image.graphql';
import { assessmentRubricsFragment } from './sections/rubrics/rubrics.graphql';
import { completionFragment } from 'approot/planner/manage/planner.graphql';
import { assessmentTeachingLearningSequenceFragment } from './sections/teaching-learning-sequence/teaching-learning-sequence.graphql';
import { materialsFragment } from 'approot/shared/graphql/lesson/lesson.graphql';
import { assessmentAssignFragment } from 'approot/shared/assign/assign-assessment.graphql';

// Note: if you change the query name: GetAssessmentById
// also update in apollo.tsx RETRY_OPERATIONS
export const GET_ASSESSMENT = gql`
  query GetAssessmentById($input: GetAssessmentByIdInput!) {
    getAssessmentById(input: $input) {
      ...AssessmentHeroImageFragment
      ...AssessmentLandscapeImageFragment
      ...AssessmentSquareImageFragment
      ...AssessmentDetailsFragment
      ...AssessmentOutcomesFragment
      ...AssessmentStimulusFragment
      ...AssessmentWorksheetsFragment
      ...AssessmentAssignFragment
      ...AssessmentRubricsFragment
      ...AssessmentForLearningToolFragment
      ...AssessmentTeachingLearningSequenceFragment
      slug
      overviewJson
      canManageCurrentContent
      isAnnotated
      archivedAt
      completion {
        ...Completion
      }
      materials {
        ...MaterialsFragment
      }
      assessmentActivities {
        id
        language
        status
        version
        isAutomarkable
      }
    }
  }
  ${assessmentDetailsFragment}
  ${assessmentHeroImageFragment}
  ${assessmentLandscapeImageFragment}
  ${assessmentSquareImageFragment}
  ${AssessmentOutcomesFragment}
  ${assessmentStimulusFragment}
  ${assessmentWorksheetsFragment}
  ${assessmentAssignFragment}
  ${assessmentRubricsFragment}
  ${assessmentForLearningToolFragment}
  ${completionFragment}
  ${assessmentTeachingLearningSequenceFragment}
  ${materialsFragment}
`;

export const UPDATE_ASSESSMENT_BOOKMARKS = gql`
  mutation UpdateAssessmentBookmark($input: UpdateAssessmentBookmarkInput!) {
    updateAssessmentBookmark(input: $input) {
      id
      isAssigned
      ...AssessmentAssignFragment
    }
  }
  ${assessmentAssignFragment}
`;
